module.exports = __webpack_public_path__ + "static/img/logo_shdjxy.40c062d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_shdjxy.png
// module id = ZxYX
// module chunks = 15